import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Link, useNavigate } from "react-router-dom";
import SliderContainer from "./components/SliderContainer";
import Banner from "./components/Banner";
import axios from "axios";
import { base_url } from "../context/Authcontext";
import '../../src/assets/AdminCss/card.css';
import CategoryGrid from "./components/CategoryGrid";
import ScrollableContent from "./components/ScrollableContent";
import ProviderMarquee from "./components/ProviderMarquee";

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero
  const day = date.getDate().toString().padStart(2, '0'); // Add leading zero
  return `${year}-${month}-${day}`; // Format as 'YYYY-MM-DD'
};


const compareWithToday = (openDate) => {
  const now = new Date();
  
  // Convert openDate string to a Date object
  const eventDateObj = new Date(openDate);
  
  // Format the current date and openDate to 'YYYY-MM-DD'
  const todayDate = formatDate(now); // today's date in 'YYYY-MM-DD' format
  const eventDateFormatted = formatDate(eventDateObj); // event date in 'YYYY-MM-DD' format

  // Return true if the event date is equal to today's date
  return todayDate === eventDateFormatted;
};

const Inplay = ({ data }) => {
  const navigate= useNavigate();
  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState([]);
  const [loading, setLoading] = useState(true);


  const matchData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      // console.log("Data is ", data)

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });
      // console.log('all',allData);
      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }finally{
      setLoading(false);
    }
  };

  const footballData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/footballapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }finally{
      setLoading(false);
    }
  };

  const tennisData = async () => {
 
    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (compareWithToday(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }finally{
      setLoading(false);
    }
  };


  const oddsData= async(req, res)=> {
    let marketid=[];

    try{

      for (let item of cricket){

        marketid.push(item.marketId);
      }
      // console.log(marketid);


      const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      // console.log('marketid',JSON.parse(response.data));
      const result= JSON.parse(response.data);

      // console.log(result);
      setAvail(result);


    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {

    const fetchData = async () => {
      if (data === 0) {
        await matchData();
      } 
      else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      };
    };
      fetchData();
  
  }, [data]);

  useEffect(() => {
    if (cricket.length > 0) {
      oddsData();
    }
  }, [cricket]);
  // console.log('vall',cricket);
  // console.log(avail);
  // console.log('avaaill',avail);

  const handleClick= (item)=>{
    // console.log(item);
    // console.log('tennis player deepanshu',item);

    sessionStorage.setItem('marketId', item.marketId);
    sessionStorage.setItem('competetionid', item.competition.id);
    sessionStorage.setItem('eventid', item?.event.id);
    sessionStorage.setItem('time',item?.event.openDate);
    sessionStorage.setItem('competitionname',item?.competition.name);
    sessionStorage.setItem('eventname',item?.event.name);

  if(item?.eventType.name==="Cricket"){
    navigate('/cricketBet');
    sessionStorage.setItem('selectionid1',item?.runners[0].selectionId);
    sessionStorage.setItem('selectionid2',item?.runners[1].selectionId);

    sessionStorage.setItem('runner1', item.runners[0].runnerName);
    sessionStorage.setItem('runner2', item.runners[1].runnerName);

    if(item?.runners[2]){
      sessionStorage.setItem('selectionid3',item?.runners[2].selectionId);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);
    }

   
  }else if(item?.eventType.name==="Soccer"){
    navigate('/footBAllBet');
    sessionStorage.setItem('selectionid1',item?.runners[0].selectionId);
    sessionStorage.setItem('selectionid2',item?.runners[1].selectionId);

    sessionStorage.setItem('runner1', item.runners[0].runnerName);
    sessionStorage.setItem('runner2', item.runners[1].runnerName);

    if(item?.runners[2]){
      sessionStorage.setItem('selectionid3',item?.runners[2].selectionId);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);
    }



  }else if(item?.eventType.name==="Tennis"){
    navigate('/tennis');
    sessionStorage.setItem('selectionid1',item?.runners[0].selectionId);
    sessionStorage.setItem('selectionid2',item?.runners[1].selectionId);

    sessionStorage.setItem('runner1', item.runners[0].runnerName);
    sessionStorage.setItem('runner2', item.runners[1].runnerName);

    if(item?.runners[2]){
      sessionStorage.setItem('selectionid3',item?.runners[2].selectionId);
      sessionStorage.setItem('runner3', item.runners[2].runnerName);
    }
  }

  // console.log("Cricket dats is ", cricket)

  }

  // console.log('avail',avail);

  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">

                {cricket.length > 0 ? (
                  cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId]?.length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];
                    // console.log('arrAnsu',marketData);
               

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competitionId}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="text-black fszz">Today</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted"
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>handleClick(item)}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1]?.runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                             
                             {/* <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div> */}
                                  <div
  _ngcontent-jrx-c94=""
  className={`${
    new Date() >= new Date(item?.event.openDate)
      ? "green-circle inplay-blinker ng-star-inserted"
      : ""
  }`}
></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                              {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}

                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Tomorrow = ({ data }) => {
  const navigate= useNavigate();
  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState();

  
  
  const isTomorrow = (eventDate) => {
    const dateObj = new Date(eventDate); // Create Date object from eventDate string
  
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid event date:", eventDate); // If date is invalid
      return false;
    }
  
    const now = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(now.getDate() + 1); // Set tomorrow's date
  
    const tomorrowFormatted = formatDate(tomorrow);
    const eventFormatted = formatDate(dateObj); // Format event date
  
    return tomorrowFormatted === eventFormatted; // Compare only the date part
  };


  const matchData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      // console.log("Data is ", data)

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isTomorrow(openDate)) {
          allData.push(dta);
        }
      });
      // console.log('all',allData);
      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/footballapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const oddsData= async(req, res)=> {
    let marketid=[];

    try{

      for (let item of cricket){

        marketid.push(item.marketId);
      }
      // console.log(marketid);


      const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      // console.log('marketid',JSON.parse(response.data));
      const result= JSON.parse(response.data);

      // console.log(result);
      setAvail(result);


    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {

    
    const fetchData = async () => {
      if (data === 0) {
        await matchData();
      }
       else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      };
    };

  fetchData();
  }, [data]);

  
  useEffect(() => {
    if (cricket.length > 0) {
      oddsData();
    }
  }, [cricket]);
  // console.log(cricket);


  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" >
              {cricket?.length > 0 ? (
                cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId]?.length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competition?.id}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                        <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</span> <span className="text-black fszz">Tomorrow</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted" 
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>navigate('/cricketBet',
                                        sessionStorage.setItem('marketId', item.marketId),
                                        sessionStorage.setItem('competetionid', item.competition.id),
                                        sessionStorage.setItem('eventid', item.event.id),
                                        sessionStorage.setItem('time',item?.event.openDate),
                                        sessionStorage.setItem('competitionname',item?.competition.name),
                                        sessionStorage.setItem('eventname',item?.event.name),
                                        sessionStorage.setItem('selectionid1',item?.runners[0].selectionId),
                                        sessionStorage.setItem('selectionid2',item?.runners[1].selectionId),

                                        sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                        sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                      { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1].runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                          
                          <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                  {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                        {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}
                                          
                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

                {/* virtualCricket */}
                {/* {data === 0 && (
                  <div>
                    <div
                      _ngcontent-jrx-c94=""
                      className="virtual-sport status-box ng-star-inserted"
                    >
                      <span
                        _ngcontent-jrx-c94=""
                        className="new-disp-flex market-name"
                      >
                        <img
                          _ngcontent-jrx-c94=""
                          src="/assets/images/virtual-cricket.svg"
                          alt="Virtual CricketKheloyaar360"
                        />{" "}
                        Virtual Cricket
                      </span>
                      <span
                        _ngcontent-jrx-c94=""
                        routerlink="/sports/competitionsmarkets/70707070"
                        className="see-more"
                        tabIndex="0"
                      >
                        {" "}
                        View More
                      </span>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Dolphins{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  Western Province{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Warriors{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  North west{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Upcoming = ({ data }) => {
  const navigate=useNavigate();

  const [cricket, setCricket]= useState([]);
  const [avail, setAvail]= useState([]);

  
  // Function to check if event is after tomorrow
  const isAfterTomorrow = (eventDate) => {
    const dateObj = new Date(eventDate); // Create Date object from eventDate string
  
    if (isNaN(dateObj.getTime())) {
      console.error("Invalid event date:", eventDate); // If date is invalid
      return false;
    }
  
    const now = new Date();
    const afterTomorrow = new Date();
    afterTomorrow.setDate(now.getDate() + 2); // Get the day after tomorrow
  
    // Format both the event date and the "after tomorrow" date to 'YYYY-MM-DD'
    const eventFormatted = formatDate(dateObj);
    const afterTomorrowFormatted = formatDate(afterTomorrow);
  
    // Return true if the event date is greater than or equal to the day after tomorrow
    return eventFormatted >= afterTomorrowFormatted;
  };
  
  const matchData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/matchapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      // console.log("Data is ", data)

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });
      // console.log('all',allData);
      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const footballData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/footballapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;
      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const tennisData = async () => {

    try {
      const response = await axios.get(
        base_url + '/api/webapi/tennisapi',
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // console.log("API Response:", response?.data.result);
      const data= response?.data.result;

      
      const allData = [];
      data?.forEach((dta) => {
        const openDate = dta?.event.openDate;
        
        // Use the updated compareWithToday function
        if (isAfterTomorrow(openDate)) {
          allData.push(dta);
        }
      });

      setCricket(allData);
    } catch (error) {
      console.error("API Error:", error);
    }
  };


  const oddsData= async(req, res)=> {
    let marketid=[];

    try{

      for (let item of cricket){

        marketid.push(item.marketId);
      }
      // console.log(marketid);


      const response= await axios.post(base_url + `/api/webapi/market/wholeMarket`,
        marketid,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )

      // console.log('marketid',JSON.parse(response.data));
      const result= JSON.parse(response.data);

      // console.log(result);
      setAvail(result);


    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {

    const fetchData = async () => {
      if (data === 0) {
        await matchData();
      } 
      else if (data === 1) {
        await footballData();
      } else if (data === 2) {
        await tennisData();
      };
    };

  fetchData();

  
  }, [data]);

  
  useEffect(() => {
    if (cricket.length > 0) {
      oddsData();
    }
  }, [cricket]);


  return (
    <>
      <div _ngcontent-jrx-c94="" className="wrap-conatiner">
        <div _ngcontent-jrx-c94="">
          <div
            _ngcontent-jrx-c94=""
            className="section tabs_boxes_section no-pad-bot no-pad-top"
          >
            <div _ngcontent-jrx-c94="" className="">
              <div _ngcontent-jrx-c94="" className="sports-wrapper">
              {cricket?.length > 0 ? (
                cricket.filter(
                    (item) =>
                      avail[item.marketId] &&
                      avail[item.marketId]?.length > 0 &&
                      avail[item.marketId].some(
                        (market) =>
                          (market?.ex?.availableToBack?.length > 0 || market?.ex?.availableToLay?.length > 0)
                      )
                  ).map((item, index) => {
                    const marketData = avail[item.marketId] || [];

                    return (
                      <div
                        key={index}
                        _ngcontent-jrx-c94=""
                        id={item?.competition?.id}
                        className="col-12 ng-star-inserted"
                        style={{ position: "relative" }}
                      >
                         <span className="text-black fszz">{new Date(item?.event.openDate).toLocaleString().split("T")[0]}</span>
                          {/* <p>{item.marketId}</p> */}
                        <div _ngcontent-jrx-c94="" className="ng-star-inserted" 
                          >
                          <div
                            _ngcontent-jrx-c94=""
                            className="section_details_box upcoming-data"
                          >
                            {/* {item.isStarted && (
                              <span
                                _ngcontent-jrx-c94=""
                                className="innerHTMLScore upcoming-score ng-star-inserted"
                              >
                                <div className="cricket-info">
                                  <div className="score" 
                                  >
                                    <span>
                                      {item.title1}
                                      <span className="vOver">(45.0)</span>
                                    </span>
                                    <span className="vRun">
                                      0 - 0 - 0 - 0 - 1 - 0 -{" "}
                                    </span>
                                    <span>
                                      {item.title2}
                                      <span className="vOver">(0.0)</span>
                                    </span>
                                  </div>
                                </div>
                              </span>
                            )} */}
                            
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-type-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="runnners-odds-details"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="sport-name-wrapper"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_box_team"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_box_t_name t_left fs-4"
                                      onClick={()=>navigate('/cricketBet',
                                        sessionStorage.setItem('marketId', item.marketId),
                                        sessionStorage.setItem('competetionid', item.competition.id),
                                        sessionStorage.setItem('eventid', item.event.id),
                                        sessionStorage.setItem('time',item?.event.openDate),
                                        sessionStorage.setItem('competitionname',item?.competition.name),
                                        sessionStorage.setItem('eventname',item?.event.name),
                                        sessionStorage.setItem('selectionid1',item?.runners[0].selectionId),
                                        sessionStorage.setItem('selectionid2',item?.runners[1].selectionId),

                                        sessionStorage.setItem('runner1', item.runners[0].runnerName),
                                        sessionStorage.setItem('runner2', item.runners[1].runnerName),
                                      { state: { marketId: item.marketId, runner1: item.runners[0].runnerName, runner2: item.runners[1].runnerName } })}
                                    >
                                      {" "}
                                      {item.runners[0].runnerName}{" "}
                                      <span
                                        _ngcontent-jrx-c94=""
                                        className="vs ng-star-inserted"
                                      >
                                        {" "}
                                        vs{" "}
                                      </span>
                                      {item.runners[1].runnerName}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="middle-detail"
                                >
                                 <div
                                    _ngcontent-jrx-c94=""
                                    className={`${
                                      item.isStarted
                                        ? "green-circle inplay-blinker ng-star-inserted"
                                        : ""
                                    }`}
                                  ></div>
                                  <img
                                    _ngcontent-jrx-c94=""
                                    className="small-grid ng-star-inserted"
                                    style={{ height: "10px" }}
                                    src="/assets/images/tv.svg"
                                    alt="TVKheloyaar360"
                                  />
                                
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid"
                                  >
                                    <span _ngcontent-jrx-c94=""> BM</span>
                                  </div>
                                  {/* <div
                                    _ngcontent-jrx-c94=""
                                    className="small-grid d-md-block d-none"
                                  >
                                    <span _ngcontent-jrx-c94=""> BF</span>
                                  </div> */}
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_odds_boxes_inn details_small_box_wrapper"
                                  style={{ position: "relative" }}
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes"
                                  >
                                    <div
                                      _ngcontent-jrx-c94=""
                                      className="details_small_boxes_let"
                                    >
                                      <div
                                        _ngcontent-jrx-c94=""
                                        className="details_small_boxes_inn ng-star-inserted"
                                      >

                        {marketData && marketData.length > 0 ? (
                                        <div className="d-flex runnners-odds-details gap-1">
                                          {(() => {
                                            let backDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToBack?.length > 0
                                                ? [{ price: market.ex.availableToBack[0].price, type: "Back" }]
                                                : []
                                            );
                                            let layDivs = marketData.flatMap(market =>
                                              market?.ex?.availableToLay?.length > 0
                                                ? [{ price: market.ex.availableToLay[0].price, type: "Lay" }]
                                                : []
                                            );
                                            
                                            // Fill up with empty divs if needed to ensure 6 elements
                                            while (backDivs.length < 2) backDivs.push({ price: null, type: "Back" });
                                            while (layDivs.length < 2) layDivs.push({ price: null, type: "Lay" });

                                            let combinedDivs = [
                                              backDivs[0],
                                              layDivs[0],
                                              { price: null, type: "Back" }, // Empty Back
                                              { price: null, type: "Lay" }, // Empty Lay
                                              backDivs[1],
                                              layDivs[1],
                                            ];

                                            return combinedDivs.map((item, index) => (
                                              <app-oddsbutton key={index}>
                                                <div
                                                  id={index}
                                                  className={`d-md-flex ${
                                                    item.type === "Lay" ? "bg-pink1" : ""
                                                  } d-none d-sm-none details_small_blue_box odds-box `}
                                                  
                                                >
                                                  <span className="ng-star-inserted">
                                                    {item.price !== null ? item.price : "--"}
                                                  </span>
                                                </div>
                                              </app-oddsbutton>
                                            ));
                                          })()}
                                        </div>
                                      ): (
                          <div>No matches found.</div>
                        )}

                                      </div>
                                    </div>
                                    <div
                                      _ngcontent-jrx-c94=""
                                      style={{ clear: "both" }}
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div>No Matches Found.</div>
                )}

                {/* virtualCricket */}
                {/* {data === 0 && (
                  <div>
                    <div
                      _ngcontent-jrx-c94=""
                      className="virtual-sport status-box ng-star-inserted"
                    >
                      <span
                        _ngcontent-jrx-c94=""
                        className="new-disp-flex market-name"
                      >
                        <img
                          _ngcontent-jrx-c94=""
                          src="/assets/images/virtual-cricket.svg"
                          alt="Virtual CricketKheloyaar360"
                        />{" "}
                        Virtual Cricket
                      </span>
                      <span
                        _ngcontent-jrx-c94=""
                        routerlink="/sports/competitionsmarkets/70707070"
                        className="see-more"
                        tabIndex="0"
                      >
                        {" "}
                        View More
                      </span>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Dolphins{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  Western Province{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div _ngcontent-jrx-c94="" className="ng-star-inserted">
                      <div
                        _ngcontent-jrx-c94=""
                        className="section_details_box upcoming-data"
                      >
                        <div
                          _ngcontent-jrx-c94=""
                          className="inplay-btn upcoming-score ng-star-inserted"
                        >
                          {" "}
                          In Play
                        </div>
                        <div
                          _ngcontent-jrx-c94=""
                          className="sport-type-detail"
                        >
                          <div
                            _ngcontent-jrx-c94=""
                            className="runnners-odds-details"
                          >
                            <div
                              _ngcontent-jrx-c94=""
                              className="sport-name-wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_box_team"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_box_t_name t_left"
                                  onClick={()=>navigate('/cricketBet')}
                                >
                                  {" "}
                                  Warriors{" "}
                                  <span _ngcontent-jrx-c94="" className="vs">
                                    {" "}
                                    vs{" "}
                                  </span>
                                  North west{" "}
                                </div>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="middle-detail"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="green-circle inplay-blinker ng-star-inserted"
                              ></div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> LMT</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> XTRA</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> FM</span>
                              </div>
                              <div _ngcontent-jrx-c94="" className="small-grid">
                                <span _ngcontent-jrx-c94=""> BM</span>
                              </div>
                              <div
                                _ngcontent-jrx-c94=""
                                className="small-grid d-md-block d-none"
                              >
                                <span _ngcontent-jrx-c94=""> BF</span>
                              </div>
                            </div>
                            <div
                              _ngcontent-jrx-c94=""
                              className="details_odds_boxes_inn details_small_box_wrapper"
                            >
                              <div
                                _ngcontent-jrx-c94=""
                                className="details_small_boxes"
                              >
                                <div
                                  _ngcontent-jrx-c94=""
                                  className="details_small_boxes_let"
                                >
                                  <div
                                    _ngcontent-jrx-c94=""
                                    className="details_small_boxes_inn ng-star-inserted"
                                  >
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_blue_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box lesser_odds_opacity odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                      <div className="box_without_size d-flex d-md-none d-sm-flex details_small_pink_box lesser_odds_opacity small_box_col ng-star-inserted">
                                        <span appratehighlight=""> </span>
                                      </div>
                                    </app-oddsbutton>{" "}
                                    &nbsp; &nbsp; &nbsp;{" "}
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_blue_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                    <app-oddsbutton _ngcontent-jrx-c94="">
                                      <div className="d-md-flex d-none d-sm-none details_small_pink_box odds-box">
                                        <span
                                          appratehighlight=""
                                          className="ng-star-inserted"
                                        ></span>
                                      </div>
                                    </app-oddsbutton>
                                  </div>
                                </div>
                                <div
                                  _ngcontent-jrx-c94=""
                                  style={{ clear: "both" }}
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


export const Home = () => {
  const [isSidebar, setSidebar] = useState(false);
  const [isInplay, setInplay] = useState(true);
  const [isTomorrow, setTomorrow] = useState(false);
  const [isUpcoming, setUpcoming] = useState(false);
  const [isActive, setActiveLink] = useState(0);
  const [loading, setLoading] = useState(false);

  const [jiliGames, setJiliGames]= useState([]);
  const [token, setToken]= useState();
  const [casino, setCasino]= useState([]);
  const [ent, setEnt]= useState([]);
  const [endorphina, setEndorphina]= useState([]);
  const [latest, setLatest]= useState([]);
  const [evolution, setEvolution]= useState([]);

  const handlePlay = (id) => {
    setInplay(false);
    setTomorrow(false);
    setUpcoming(false);

    if (id === "inplay") {
      setInplay(true);
      setLoading(true);

    } else if (id === "tomorrow") {
      setTomorrow(true);
      setLoading(true);

    } else {
      setUpcoming(true);
      setLoading(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0,0);
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };
    handleResize();
  }, []);

  useEffect(() => {
    if (isInplay || isTomorrow || isUpcoming) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        
      }, 2000);
    }
  }, [isInplay, isTomorrow, isUpcoming]);


  useEffect(() =>{


    const matchData = async () => {
      // console.log("implay clicket called before")
     
      try {
        const response = await axios.get(
          base_url + '/api/webapi/matchapi',
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("implay clicket called")
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;
        // console.log("Data is ", data)
  
        
        // First, extract all openDates to pass to compareWithToday
        const allOpenDates = data?.map(dta => dta?.openDate);
        
        const allData = [];
        data?.forEach((dta) => {
          const openDate = dta?.openDate;
          
          // Use the updated compareWithToday function
          if (compareWithToday(openDate, allOpenDates)) {
            allData.push(dta);
          }
        });
  
       
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    const footballData = async () => {
      // console.log("implay football called before")
    
      try {
        const response = await axios.get(
          base_url + '/api/webapi/footballapi',
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        // console.log("implay football called")
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;
  // console.log(data);
        
        // First, extract all openDates to pass to compareWithToday
        const allOpenDates = data?.map(dta => dta?.openDate);
        
        const allData = [];
        data?.forEach((dta) => {
          const openDate = dta?.openDate;
          
          // Use the updated compareWithToday function
          if (compareWithToday(openDate, allOpenDates)) {
            allData.push(dta);
          }
        });
  
      
      } catch (error) {
        console.error("API Error:", error);
      }
    };
  
    const tennisData = async () => {
      // console.log("implay tennis is called be before")
     
      try {
        const response = await axios.get(
          base_url + '/api/webapi/tennisapi',
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("implay tennis is called")
        // console.log("API Response:", response?.data.result);
        const data= response?.data.result;
  
        
        // First, extract all openDates to pass to compareWithToday
        const allOpenDates = data?.map(dta => dta?.openDate);
        
        const allData = [];
        data?.forEach((dta) => {
          const openDate = dta?.openDate;
          
          // Use the updated compareWithToday function
          if (compareWithToday(openDate, allOpenDates)) {
            allData.push(dta);
          }
        });
  
        
      } catch (error) {
        console.error("API Error:", error);
      }
    };


    const casinogames = async () => {
      try {
        const response = await axios.get(base_url + '/api/webapi/valedTokenHome', {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          },
        });
    
        const games = response?.data?.games?.items || [];

        // console.logI("Games Are ", games)
        const tokenn = response?.data?.token;
        localStorage.setItem('game_token',tokenn);
    
        // Provider groups casino
        const allowedProviders = [
          'Playtech Live',
          'Playtech Casino',
          'Skywind Casino',
          'RTG Slots',
          '7Mojos Casino',
          'ICONIC21',
          'Habanero'
        ];
    
        // ent
        const voltProvide = ['Red Tiger Gaming', 'Betgames', 'Netgame', 'OnlyPlay', 'CQ9 Casino', 'Live88'];
    
        // endor
        const endorphina = ['Qora', 'Ezugi', 'Gamizx', 'Triple PG', 'Evoplay'];
    
        // latest
        const latst = [
          'ICONIC21',
          'Live88',
          "Spribe",
          'Aviatrix'
        ];
    
        // evolution
        const evoluton = [
          'Evolution Gaming', 'Playtech Live',
        ];
    
        // Buckets
        const jili = [];
        const casino = [];
        const ent = [];
        const endor = [];
        const latest = [];
        const evolution = [];
    
        // Single loop to classify games
        games.forEach((game) => {
          const providerName = game?.provider?.name;
          if (!providerName) return;
    
          if (providerName === 'Jili') {
            jili.push(game);
          }
    
          if (allowedProviders.includes(providerName)) {
            casino.push(game);
          }
    
          if (voltProvide.includes(providerName)) {
            ent.push(game);
          }
    
          if (endorphina.includes(providerName)) {
            endor.push(game);
          }
    
          if (latst.includes(providerName)) {
            latest.push(game);
          }
    
          if (evoluton.includes(providerName)) {
            evolution.push(game);
          }
        });
    
        // Set state
        setJiliGames(jili);
        setCasino(casino);
        setEnt(ent);
        setEndorphina(endor);
        setLatest(latest);
        setEvolution(evolution);
        setToken(tokenn);
    
      } catch (err) {
        console.error('Error fetching games:', err);
      }
    };

    casinogames();

    matchData();
    footballData();
    tennisData();
    
  })

  const handleActiveLink = (index) => {
    
    setActiveLink(index);
    
  };


  const scrollableList = [
    { name: "Cricket", imgLink: "/assets/images/cricket.svg" },
    { name: "Football", imgLink: "/assets/images/football.webp" },
    { name: "Tennis", imgLink: "/assets/images/Tennis New.svg" },
    { name: "Basketball", imgLink: "/assets/images/Basketbaalls.svg" },
    { name: "Baseball", imgLink: "/assets/images/baseball-svgrepo-com 1.svg" },
  ];


  useEffect(()=>{
    const casinogames = async () => {
      try {
        const response = await axios.get(base_url + '/api/valid/token', {
          withCredentials: true,
          headers: {
            'content-type': 'application/json',
          },
        });
    
        const games = response?.data?.games?.items || [];
        const tokenn = response?.data?.token;
        localStorage.setItem('game_token',tokenn);
    
        // Provider groups casino
        const allowedProviders = [
          'Playtech Live',
          'Playtech Casino',
          'Skywind Casino',
          'RTG Slots',
          '7Mojos Casino',
          'ICONIC21',
          'Habanero'
        ];
    
        // ent
        const voltProvide = ['Red Tiger Gaming', 'Betgames', 'Netgame', 'OnlyPlay', 'CQ9 Casino', 'Live88'];
    
        // endor
        const endorphina = ['Qora', 'Ezugi', 'Gamizx', 'Triple PG', 'Evoplay'];
    
        // latest
        const latst = [
          'ICONIC21',
          'Live88',
          "Spribe",
          'Aviatrix'
        ];
    
        // evolution
        const evoluton = [
          'Evolution Gaming',
        ];
    
        // Buckets
        const jili = [];
        const casino = [];
        const ent = [];
        const endor = [];
        const latest = [];
        const evolution = [];
    
        // Single loop to classify games
        games.forEach((game) => {
          const providerName = game?.provider?.name;
          if (!providerName) return;
    
          if (providerName === 'Jili') {
            jili.push(game);
          }
    
          if (allowedProviders.includes(providerName)) {
            casino.push(game);
          }
    
          if (voltProvide.includes(providerName)) {
            ent.push(game);
          }
    
          if (endorphina.includes(providerName)) {
            endor.push(game);
          }
    
          if (latst.includes(providerName)) {
            latest.push(game);
          }
    
          if (evoluton.includes(providerName)) {
            evolution.push(game);
          }
        });
    
        // Set state
        setJiliGames(jili);
        setCasino(casino);
        setEnt(ent);
        setEndorphina(endor);
        setLatest(latest);
        setEvolution(evolution);
        setToken(tokenn);
    
      } catch (err) {
        console.error('Error fetching games:', err);
      }
    };
    

    casinogames();
  },[]);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16" >
      
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <div className="news-bar">
                  <marquee style={{ width: '100%' }}>
                    <p className="m-0 w-100">
                      👉IPL MONTH DHAMAKA OFFER..GET 3% REFILL BONUS ON EVERY DEPOSIT... USDT DEPOSIT OPTION IS ALSO AVAILABLE ON OUR SITE👈👈...TO CONFIRM DEPOSIT BRANCH NUMBER CONTACT HELPDESK NO +265899881378
                    </p>
                  </marquee>
                </div>

                <div
                  _ngcontent-jrx-c95=""
                  className="sports-casino mt-15 d-none"
                >
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/4"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Cricket
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/cricket.svg"
                        alt="Cricket_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/1"
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Football
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/football.webp"
                        alt="Football_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/2"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Tennis
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/tennis.webp"
                        alt="Tennis_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/7522"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Basketball
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/basketball.webp"
                        alt="Basketball_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/7/ALL"
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Horse Racing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Horse-racing_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/raceschedule/4339/ALL"
                      style={{
                        background:
                          "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Greyhound
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/Greyhound transparent.gif"
                        style={{ height: "35px" }}
                        alt="Greyhound_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/sports/sportsbyid/6"
                      style={{
                        background:
                          "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Boxing
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/horse-racing.gif"
                        style={{ height: "35px" }}
                        alt="Boxing_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>
                <div _ngcontent-jrx-c95="" className="sports-casino d-none">
                  <ul _ngcontent-jrx-c95="" className="popular-tab">
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/LIVECASINO"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Live Casino
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/live_casino.webp"
                        alt="Live Casino_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/ROULETTE"
                      style={{
                        background:
                          "linear-gradient(90deg, #20a635 2.29%, #22ff7a 83.94%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Casino Lobby
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino_lobby.webp"
                        alt="Casino Lobby_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crazy Time
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crazy_time.webp"
                        alt="Crazy Time_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/INSTANTWIN"
                      style={{
                        background:
                          "linear-gradient(270deg, #3984f7 0%, #242156 100%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Crash Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/crash_games.webp"
                        alt="Crash Games_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Virtual Sports
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/virtual_sports.webp"
                        alt="Virtual Sports_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      style={{
                        background:
                          "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
                      }}
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Evolution
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/evolution.webp"
                        alt="Evolution_Kheloyaar360"
                      />
                    </li>
                    <li
                      _ngcontent-jrx-c95=""
                      routerlink="/casinos/games/TABLEGAME"
                      style={{
                        background:
                          "linear-gradient(91deg, #ec62e2 0.66%, #9c31f0 99.47%)",
                      }}
                      tabIndex="0"
                    >
                      <Link
                        _ngcontent-jrx-c95=""
                        className="type-heading typehead"
                      >
                        Table Games
                      </Link>
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/table_games.webp"
                        alt="Table Games_Kheloyaar360"
                      />
                    </li>
                  </ul>
                </div>
                <Banner />

                <CategoryGrid />

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >
                  <div _ngcontent-jrx-c94="" className="upcoming-container  upcoming-container2">
                    <div _ngcontent-jrx-c94="" className="upcoming">
                      <div _ngcontent-jrx-c94="" className="items">
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isInplay ? "active-bar" : ""}`}
                          onClick={() => handlePlay("inplay")}
                        >
                          Inplay
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isTomorrow ? "active-bar" : ""}`}
                          onClick={() => handlePlay("tomorrow")}
                        >
                          Tomorrow
                        </span>
                        <span
                          _ngcontent-jrx-c94=""
                          className={`inp ${isUpcoming ? "active-bar" : ""}`}
                          onClick={() => handlePlay("upcoming")}
                        >
                          Upcoming
                        </span>
                      </div>
                      <div
                        _ngcontent-jrx-c94=""
                        routerlink="/sports"
                        className="view-all"
                        tabIndex="0"
                      >
                        <span _ngcontent-jrx-c94="">View More</span>
                      </div>
                    </div>
                  </div>
                  <div _ngcontent-jrx-c94="" className="scrollable-list">
                    {scrollableList.map((item, index) => {
                      return (
                        <div
                          key={index}
                          _ngcontent-jrx-c94=""
                          className={`inp list-item ${
                            isActive === index ? "active" : ""
                          } first-item ng-star-inserted`}
                          onClick={() => handleActiveLink(index)}
                        >
                          <img
                            _ngcontent-jrx-c94=""
                            src={item.imgLink}
                            alt="CricketKheloyaar360"
                          />{" "}
                          {item.name}{" "}
                        </div>
                      );
                    })}
                  </div>
                  {isInplay && <Inplay data={isActive} />}
                  {isTomorrow && <Tomorrow data={isActive} />}
                  {isUpcoming && <Upcoming data={isActive} />}
                </app-upcoming>


              {/* latest games */}
                {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/titleImg.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Latest Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{token, games:latest}}/>
                </div> */}

                    {/* hot games */}
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino2.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Hot Games</span>
                    </div>
                    <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div>
                  </div>
                  <SliderContainer CurrentSlider={{token, games:ent}}/>
                </div>


                {/* new release */}
                <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino1.png"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">New Releases</span>
                    </div>
                    {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> */}
                  </div>
                  <SliderContainer CurrentSlider={{token, games:endorphina}}/>
                </div>


                    {/* jili games */}
                <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino3.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Jili (Indian Casino)</span>
                    </div>
                    {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> */}
                  </div>
                  <SliderContainer CurrentSlider={{token, games:jiliGames}}/>
                </div>

                {/* evolution */}
                <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino4.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Evolution (Intl Casino)</span>
                    </div>
                    {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> */}
                  </div>
                  <SliderContainer CurrentSlider={{token, games:evolution}}/>
                </div>


                {/* casino games */}
                <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                  <div _ngcontent-jrx-c95="" className="popular-today-heading">
                    <div _ngcontent-jrx-c95="">
                      <img
                        _ngcontent-jrx-c95=""
                        src="/assets/images/casino5.svg"
                        alt="Popular Games_Kheloyaar360"
                      />
                      <span _ngcontent-jrx-c95="">Casino Games</span>
                    </div>
                    {/* <div _ngcontent-jrx-c95="" className="ng-star-inserted">
                      <Link
                        _ngcontent-jrx-c95=""
                        className="see-all-a"
                        to={'/jiliAll'}
                        href="https://kheloyaar360.net/casinos/games/POPULAR"
                        
                      >
                        See All
                        <svg
                          _ngcontent-jrx-c95=""
                          className="svg-inline--fa fa-arrow-right fa-w-14 iconArrow"
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="arrow-right"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 448 512"
                          data-fa-i2svg=""
                        >
                          <path
                            fill="currentColor"
                            d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
                          ></path>
                        </svg>
                      </Link>
                    </div> */}
                  </div>
                  <SliderContainer CurrentSlider={{token, games:casino}}/>
                </div>
                <ProviderMarquee/>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>

        <div className="slider-container"></div>
      </div>
    </app-root>
  );
};
